<template>
  <c-row>
    <c-col col="3" v-show="false">
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>Tambah Transaksi</strong>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div class="form-group">
            <label>Tanggal</label>
            <datetime class="date-control" v-model="history.date" v-bind:class="{ 'has-error': errors.date }" />
          </div>
          <div class="form-group">
            <label>Nilai</label>
            <button-edit-input :value="history.amount" v-bind:class="{ 'has-error': errors.amount }" :rounded="true"
              :bordered="true" @updateValue="setAmount" />
          </div>
          <div class="form-group">
            <label>Penjelasan</label>
            <input type="text" class="form-control" v-model="history.description"
              v-bind:class="{ 'has-error': errors.description }" />
          </div>
          <div class="form-group">
            <label>Keterangan</label>
            <input type="text" class="form-control" v-model="history.notes"
              v-bind:class="{ 'has-error': errors.notes }" />
          </div>
        </c-card-body>
        <c-card-footer>
          <button class="btn btn-success" @click="addTransaction">
            <i class="cil-save"></i> Save
          </button>
        </c-card-footer>
      </c-card>
    </c-col>
    <c-col col="12">
      <c-card>
        <c-card-body>
          <div class="form-group form-row">
            <label class="col-form-label col-md-2">Filter Tanggal</label>
            <div class="col-md-3">
              <datetime class="date-control" v-model="filter.date" @input="changeFilterDate" />
            </div>
          </div>
          <div style="overflow: auto">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" @click="checkOrUncheckAll" v-model="masterSelect" />
                  </th>
                  <th>Tanggal</th>
                  <th>Penjelasan Transaksi</th>
                  <th>Keterangan</th>
                  <th>Debit</th>
                  <th>Kredit</th>
                  <th>Jumlah Setor</th>
                  <th>Setor Tanggal</th>
                  <th>Via</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, k) in cashHistory.data" :key="k">
                  <td align="center" width="35">
                    <input v-if="!d.deposit_date" type="checkbox" class="mouse-pointer" v-model="d.selected"
                      @click="select(d)" />
                  </td>
                  <td>{{ d.date | dateFormat }}</td>
                  <td>{{ d.description }}</td>
                  <td>{{ d.notes }}</td>
                  <td class="right">{{ d.debit | thousandSeparator }}</td>
                  <td class="right">{{ d.credit | thousandSeparator }}</td>
                  <td class="right" v-if="d.first_data" :rowspan="d.row_span">
                    {{ d.deposit_amount | thousandSeparator }}
                  </td>
                  <td class="right" v-if="d.first_data" :rowspan="d.row_span">
                    {{ d.deposit_date | dateFormat }}
                  </td>
                  <td class="right" v-if="d.first_data" :rowspan="d.row_span">
                    {{ d.bank_name }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
        <c-card-footer>
          <div class="form-inline form-row">
            <button class="btn btn-success" @click="setorConfirm = true" v-show="setorButton">
              Setor
            </button>
            <div class="col-md-1" v-show="setorButton">
              <span class="form-control">{{
                setor.deposit_amount | thousandSeparator
                }}</span>
            </div>
            <div class="col-md-10" v-if="setorButton">
              <Paginator :paginator="cashHistory.paginate" @change="changePage" />
            </div>
            <div class="col-md-12" v-if="!setorButton">
              <Paginator :paginator="cashHistory.paginate" @change="changePage" />
            </div>
          </div>
        </c-card-footer>
        <CModal title="Setor Konfirmation" size="sm" color="success" :show.sync="setorConfirm">
          <div class="form-group">
            <label for="amount">Amount</label>
            <span type="text" class="form-control" v-bind:class="{ 'has-error': setorErrors.deposit_amount }" readonly>{{
              setor.deposit_amount | thousandSeparator }}</span>
          </div>
          <div class="form-group">
            <label for="amount">Date</label>
            <datetime type="datetime" class="date-control" v-model="setor.deposit_date"
              v-bind:class="{ 'has-error': setorErrors.deposit_date }" readonly />
          </div>
          <div class="form-group">
            <label for="amount">Bank</label>
            <select-x url="/api/v1/bank-account" size="20" placeholder="Silahkan Pilih Bank" label="name"
              v-model="setor.dataBank" v-bind:class="{ 'has-error': setorErrors.bank }" />
          </div>
          <template #footer>
            <CButton @click="setorConfirm = false" color="warning">Batal</CButton>
            <CButton @click="actionSetor" color="success">Submit</CButton>
          </template>
        </CModal>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import ButtonEditInput from "../../components/ButtonEditInput";
import SelectX from "../../components/SelectX";
import Paginator from '../../components/Paginator.vue';
export default {
  components: {
    ButtonEditInput,
    SelectX,
    Paginator,
  },
  data () {
    return {
      kasFlow: ["debit", "credit"],
      loading: true,
      history: {},
      cashHistory: {},
      paginate: {},
      currentPage: {},
      errors: [],
      filter: {},
      masterSelect: false,
      setorButton: false,
      setor: {
        ids: [],
        deposit_amount: 0,
        deposit_date: moment().format(),
      },
      setorConfirm: false,
      setorErrors: [],
    };
  },
  created () {
    this.initValue();
    this.history.created_at = moment();
    this.histories(1);
  },
  methods: {
    initValue () {
      this.history = {
        date: moment().format(),
      };
    },
    changeFilterDate () {
      this.histories(1);
    },
    checkOrUncheckAll () {
      const check = !this.masterSelect;
      const data = this.cashHistory.data;
      this.setor.ids = [];
      this.setor.deposit_amount = 0;
      for (var i in data) {
        var selected = data[i];
        selected.selected = check;
        this.cashHistory.data[i] = selected;
        this.setor.ids.push(selected.id);
        if (check) {
          this.setor.deposit_amount += selected.credit;
        }
      }
      this.setorButton = check;
    },
    select (d) {
      d.selected = !d.selected;
      if (d.selected) {
        this.setor.deposit_amount += d.credit;
        this.setorButton = d.selected;
        this.setorButton = true;
        this.setor.ids.push(d.id);
      } else {
        this.setor.deposit_amount -= d.credit;
        this.setorButton = false;
        this.masterSelect = false;
        const data = this.cashHistory.data;
        for (var i in data) {
          if (data[i].selected) {
            this.setorButton = true;
            this.masterSelect = true;
            break;
          }
        }
        /** remove id from array */
        for (var j in this.setor.ids) {
          const data = this.setor.ids[j];
          if (data == d.id) {
            this.setor.ids.splice(j, 1);
            break;
          }
        }
      }
    },
    histories (page) {
      this.loading = true;
      const date = this.filter && this.filter.date ? this.filter.date : "";
      HTTPAUTH.get(
        `/api/v1/installation-history?size=10&date=${date}&page=${page}`
      )
        .then((res) => {
          this.cashHistory = res.data;
          this.paginate = res.data.paginate;
          this.currentPage = this.paginate.page;
          this.disableLoading();
        })
        .catch(() => {
          this.disableLoading();
        });
    },
    disableLoading () {
      setTimeout(() => {
        this.loading = false;
      }, 300);
    },
    addTransaction () {
      HTTPAUTH.post("/api/v1/installation-history", this.history)
        .then(() => {
          this.histories();
          this.history = {
            created_at: moment(),
          };
        })
        .catch((eres) => {
          if (eres.response.data.message) {
            this.$toasted.error(eres.response.data.message).goAway(2000);
            this.errors = eres.response.data.errors;
            return;
          }
          this.$toasted.error(eres.response.data.user_message).goAway(2000);
        });
    },
    actionSetor () {
      if (this.setor.dataBank) {
        this.setor.bank = this.setor.dataBank.id;
      }
      HTTPAUTH.post("/api/v1/installation-history/setor", this.setor)
        .then(() => {
          this.setor = {
            ids: [],
            deposit_amount: 0,
            deposit_date: moment().format(),
          };
          this.setorConfirm = false;
          this.histories();
        })
        .catch((eres) => {
          if (eres.response.data.message) {
            this.$toasted.error(eres.response.data.message).goAway(2000);
            this.setorErrors = eres.response.data.errors;
            return;
          }
          this.$toasted.error(eres.response.data.user_message).goAway(2000);
        });
    },
    setAmount (val) {
      this.history.amount = val;
    },
    changePage (page) {
      this.histories(page);
    }
  },
  watch: {
    currentPage (pageNext) {
      this.histories(pageNext);
    },
  },
};
</script>